import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sorting",
  "use": "icon-sorting-usage",
  "viewBox": "0 0 15 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 11\" id=\"icon-sorting\"><path d=\"M2.3.5h2.3v7H2.3v-7zM0 7.5h7L3.5 11 0 7.5zm10.3 3h2.3v-7h-2.3v7zM8 3.5h7L11.5 0 8 3.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol